var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"filter-button"},[_vm._t("default"),_c('icon',{attrs:{"type":"mdi","path":_vm.icons.close,"size":14}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }